export default __webpack_public_path__ + "static/media/cover-leafText2.5fd7a793.png";